// What a request to any server carries (the identity ADR step ⑩): the platform token
// and a fresh proof, made by this browser's key, for exactly this request.
import { currentSession } from './identityServerClient.js';
import { createProof } from './proofKey.js';

/**
 * The headers for one request. No headers when signed out — the request still
 * goes, the server answers 401, and the host's handler sends the person to the
 * login screen. Every transport calls this with the method and URL it is about
 * to send, because the proof is for that request and no other.
 */
export async function authorizationHeaders({ method, url }) {
    const session = await currentSession();
    if (session === null) {
        return {};
    }
    return {
        Authorization: `DPoP ${session.accessToken}`,
        DPoP: await createProof({ method, url, accessToken: session.accessToken })
    };
}

/**
 * What a socket presents in its first frame. A browser cannot set a header on a
 * websocket, so the token and a proof for the handshake (a GET of the socket's
 * URL) ride the `authenticate` frame instead. Null when signed out.
 */
export async function socketCredentials(url) {
    const session = await currentSession();
    if (session === null) {
        return null;
    }
    return {
        accessToken: session.accessToken,
        dpopProof: await createProof({ method: 'GET', url, accessToken: session.accessToken })
    };
}

export const authorization = { authorizationHeaders, socketCredentials };
export default authorization;
